"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginService = exports.default = void 0;

var _lodash = require("lodash");

var _types = require("./types");

var _localStorage = _interopRequireDefault(require("./internal/local-storage"));

var _servicesLoginApi = _interopRequireDefault(require("./internal/services-login-api"));

var _listeners = _interopRequireDefault(require("./internal/listeners"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to get private field on non-instance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to set private field on non-instance"); } if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } return value; }

var _currentUser = new WeakMap();

var _system = new WeakMap();

var _actions = new WeakMap();

/**
 * Classe utilizada para auxiliar a autenticação do services-login
 */
class LoginService {
  constructor() {
    _currentUser.set(this, {
      writable: true,
      value: void 0
    });

    _system.set(this, {
      writable: true,
      value: ''
    });

    _actions.set(this, {
      writable: true,
      value: []
    });

    _defineProperty(this, "systemActions", []);
  }

  /**
   * Inicializa a classe de acordo com o ambiente e o sistema.
   *
   * @link [services-login](https://github.com/agro1desenvolvimento/services-login)
   */
  async initializeByEnvironment(system, environment, config) {
    await this.initializer(_objectSpread(_objectSpread({}, config), {}, {
      system,
      backendURL: _servicesLoginApi.default.fetchBackendURL(environment),
      frontendURL: _servicesLoginApi.default.fetchFrontendURL(environment)
    }));
  }
  /**
   * inicializa a classe passando os atributos necessários explicitamente.
   *
   * @link [services-login](https://github.com/agro1desenvolvimento/services-login)
   */


  async initializer(config) {
    _classPrivateFieldSet(this, _system, config.system);

    _servicesLoginApi.default.create({
      backendURL: config.backendURL,
      frontendURL: config.frontendURL
    });

    this.scopeInitializer(config.extractScopeFromUrl);
    await this.tokenInitializer(config.extractTokenFromUrl);
  }

  deleteParamFromURL(param) {
    const url = new URL(location.href);
    url.searchParams.delete(param);
    history.replaceState({}, '', url.href);
  }

  getParamFromURL(param) {
    return new URLSearchParams(location.search).get(param);
  }

  updateActions() {
    var _this$currentUser;

    const {
      scope
    } = this;
    const actions = new Set([]);
    (_this$currentUser = this.currentUser) === null || _this$currentUser === void 0 ? void 0 : _this$currentUser.roles.forEach(role => {
      if (!scope || role.scope === scope) actions.add(role.action);
    });
    this.actions = Array.from(actions.values());
  }

  validateAccess(action) {
    return this.systemActions.includes(action);
  }

  requestHeaders({
    token = this.token,
    scope = this.scope
  } = {}) {
    const result = {};
    if (token) result.Authorization = `Bearer ${token}`;
    if (scope) result['X-Scope'] = scope;
    return result;
  }

  async logout() {
    this.scope = null;
    await this.setToken(null);
    this.redirectToLogin();
  }

  get system() {
    return _classPrivateFieldGet(this, _system);
  }

  get actions() {
    return _classPrivateFieldGet(this, _actions);
  }

  set actions(actions) {
    _classPrivateFieldSet(this, _actions, actions);

    this.systemActions = actions.filter(role => role.startsWith(`${this.system}.`));
  }

  async tokenInitializer(extractFromUrl = true) {
    const urlToken = extractFromUrl ? this.getParamFromURL(_types.URLParamsKeys.token) : null;

    if (urlToken) {
      this.deleteParamFromURL(_types.URLParamsKeys.token);
      await this.setToken(urlToken);
    } else {
      await this.fetchUser();
    }
  }

  redirectInvalidUser() {
    const searchParams = {
      'authentication-error': 'true',
      system: this.system
    };
    if (this.scope) searchParams.scope = this.scope;
    this.redirectToLogin(searchParams);
  }

  redirectToLogin(searchParams = {}) {
    const urlToRedirect = new URL(_servicesLoginApi.default.frontendURL);
    Object.entries(searchParams).map(([key, value]) => urlToRedirect.searchParams.set(key, value));
    location.href = urlToRedirect.href;
  }

  addOnUserChange(listener) {
    _listeners.default.add('user', listener);
  }

  removeOnUserChange(listener) {
    _listeners.default.delete('user', listener);
  }

  async fetchUser() {
    const token = this.getLocalStorageToken();

    if (!token) {
      this.currentUser = null;
      return;
    }

    this.currentUser = (await _servicesLoginApi.default.get('/profile', {
      headers: this.requestHeaders({
        token
      })
    })).data;
  }

  setLocalStorageToken(token) {
    if (token) _localStorage.default.setItem(_types.StorageKeys.token, token);else _localStorage.default.removeItem(_types.StorageKeys.token);
  }

  getLocalStorageToken() {
    return _localStorage.default.getItem(_types.StorageKeys.token);
  }

  async setToken(token) {
    if (token === this.token || (0, _lodash.isNil)(token) && (0, _lodash.isNil)(this.token)) return;
    this.setLocalStorageToken(token);
    await this.fetchUser();
  }

  get currentUser() {
    return _classPrivateFieldGet(this, _currentUser);
  }

  set currentUser(currentUser) {
    var _classPrivateFieldGet2;

    if (currentUser === this.currentUser) return;

    _classPrivateFieldSet(this, _currentUser, currentUser);

    this.setLocalStorageToken((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _currentUser)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.token);
    this.updateActions();

    _listeners.default.call('user', this.currentUser);
  }

  get token() {
    var _this$currentUser2;

    return ((_this$currentUser2 = this.currentUser) === null || _this$currentUser2 === void 0 ? void 0 : _this$currentUser2.token) || null;
  }

  get isLoggedIn() {
    return !!this.token;
  }

  async scopeInitializer(extractFromUrl = true) {
    const urlScope = extractFromUrl ? this.getParamFromURL(_types.URLParamsKeys.scope) : null;

    if (urlScope) {
      this.deleteParamFromURL(_types.URLParamsKeys.scope);
      this.scope = urlScope;
    }
  }

  redirectToScopeSelection() {
    location.href = _servicesLoginApi.default.frontendURL;
  }

  addOnScopeChange(listener) {
    _listeners.default.add('scope', listener);
  }

  removeOnScopeChange(listener) {
    _listeners.default.delete('scope', listener);
  }

  get hasScope() {
    return !!this.scope;
  }

  get scope() {
    return _localStorage.default.getItem(_types.StorageKeys.scope);
  }

  set scope(scope) {
    if (scope) _localStorage.default.setItem(_types.StorageKeys.scope, scope);else _localStorage.default.removeItem(_types.StorageKeys.scope);
    this.updateActions();

    _listeners.default.call('scope', scope);
  }

}

exports.LoginService = LoginService;

var _default = new LoginService();

exports.default = _default;